module.exports = new __parcel__URL__("info.50298bfa.svg").toString();